import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';

import common from '@/js/lib/common';
import { linkify } from '@/js/lib/helper/linkify';
import { addHistoryItem } from '@/js/lib/api/item';
import { addFollowButton, addFollowRecommendIfItemLiked } from '@/js/lib/ui/follow-button';
import SocialShare from '@/js/components/common/ui/share.vue';
import MessageButton from '@/js/components/listing/MessageButton.vue';
import SendRequestButton from '@/js/components/listing/SendRequestButton.vue';
import SendRequestFinished from '@/js/components/listing/SendRequestFinished.vue';
import CartButton from '@/js/components/listing/cart-button.vue';
import SameCategoryItems from '@/js/components/listing/sameCategoryItems.vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import PhotoViewer from '@/js/components/www.iichi.com/organisms/PhotoViewer.vue';
import LikeButton from '@/js/components/www.iichi.com/pages/listing/item/likeButton.vue';

document.addEventListener('DOMContentLoaded', async () => {
  if ('customElements' in window) {
    const photoViewerEl = document.querySelector('photo-viewer') as HTMLElement;
    createApp({
      render: () =>
        h(PhotoViewer, {
          pictures: JSON.parse(photoViewerEl.dataset.pictures!) as {
            path: string;
            width: number;
            height: number;
            comment: string;
          }[],
          hasThumbnail: photoViewerEl.dataset.hasThumbnail === 'true',
        }),
    }).mount(photoViewerEl);
  }

  const sameCategoryItemsEl = document.querySelector('same-category-items') as HTMLElement;
  createApp({
    render: () =>
      h(SameCategoryItems, {
        categoryId: Number(sameCategoryItemsEl.dataset.categoryId),
        isVintage: sameCategoryItemsEl.dataset.isVintage === 'true',
        price: Number(sameCategoryItemsEl.dataset.price),
      }),
  }).mount(sameCategoryItemsEl);

  if ('IntersectionObserver' in window) {
    const cartButtonEl = document.querySelector('.cart-button') as HTMLDivElement;
    const cartButtonFixedEl = document.querySelector('.cart-button-fixed') as HTMLDivElement;
    const breadEl = document.querySelector('#bread') as HTMLDivElement;
    const footerMetaEl = document.querySelector('#footer-meta') as HTMLDivElement;
    const cartButtonObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          cartButtonFixedEl.style.display = entry.isIntersecting ? 'none' : 'block';
        });
      },
      {
        rootMargin: '20px 0px 600px 0px',
      },
    );
    cartButtonObserver.observe(footerMetaEl || breadEl); // アプリの場合はパンくずを監視する
    cartButtonObserver.observe(cartButtonEl); // 「カートに入れる」ボタンを後に監視する必要がある
  }

  const cartButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('cart-button');
  cartButtonEls.forEach((el) => {
    createApp({
      render: () =>
        h(CartButton, {
          itemId: Number(el.dataset.itemId),
          shopId: Number(el.dataset.shopId),
          stock: Number(el.dataset.stock),
          hasOption: Number(el.dataset.hasOption) as 1 | 0,
          isOnVacation: Number(el.dataset.isOnVacation) as 1 | 0,
          buttonLabel: el.dataset.buttonLabel,
        }),
    }).mount(el);
  });

  const socialShareEl = document.querySelector('social-share') as HTMLElement;
  createApp({
    render: () =>
      h(SocialShare, {
        title: socialShareEl.dataset.title,
        url: socialShareEl.dataset.url,
      }),
  }).mount(socialShareEl);

  const messageButtonEl = document.querySelector('message-button') as HTMLElement;
  if (messageButtonEl) {
    createApp({
      render: () =>
        h(MessageButton, {
          disabled: messageButtonEl.dataset.disabled === 'true',
          itemId: Number(messageButtonEl.dataset.itemId),
          shopId: Number(messageButtonEl.dataset.shopId),
          subject: messageButtonEl.dataset.subject,
        }),
    }).mount(messageButtonEl);
  }

  const descriptionEl = document.querySelector('#item-description .text') as HTMLParagraphElement;
  descriptionEl.innerHTML = linkify(descriptionEl.innerHTML);

  const iMenuEls: NodeListOf<HTMLElement> = document.querySelectorAll('i-menu');
  iMenuEls.forEach((el: HTMLElement) => {
    const [linkText, menuText] = [...el.querySelectorAll('template')];
    const linkHtml = linkText.innerHTML;
    const menuHtml = menuText.innerHTML;
    createApp({
      render: () =>
        h(
          IMenu,
          {
            hasUnderline: el.dataset.hasUnderline === 'true',
            width: el.dataset.width,
            title: el.dataset.title,
            placement: el.dataset.placement,
            offset: el.dataset.offset ? Number(el.dataset.offset) : undefined,
          },
          {
            link: () => h('div', { innerHTML: linkHtml }),
            menu: () => h('div', { innerHTML: menuHtml }),
          },
        ),
    }).mount(el);
  });

  const likeButtonEl = document.querySelector('#item-like like-button') as HTMLElement;
  if (likeButtonEl) {
    createApp({
      render: () =>
        h(LikeButton, {
          itemId: Number(likeButtonEl.dataset.itemId),
        }),
    }).mount(likeButtonEl);
  }

  await addFollowButton();
  addFollowRecommendIfItemLiked();

  addHistoryItem({ itemId: common.env.Pallet.Item!.itemId });

  const sendRequestButtonEl = document.querySelector('send-request-button') as HTMLElement;
  if (sendRequestButtonEl) {
    createApp({
      render: () =>
        h(SendRequestButton, {
          itemId: Number(sendRequestButtonEl.dataset.itemId),
          shopId: Number(sendRequestButtonEl.dataset.shopId),
          isMe: Number(sendRequestButtonEl.dataset.isMe),
          isSubscribed: Number(sendRequestButtonEl.dataset.isSubscribed),
        }),
    }).mount(sendRequestButtonEl);
  }

  const sendRequestFinishedEl = document.querySelector('send-request-finished');
  if (sendRequestFinishedEl) {
    createApp(SendRequestFinished).mount(sendRequestFinishedEl);
  }
});
